import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout/Layout';
import AdminMenu from '../../components/Layout/AdminMenu';
import { useAuth } from '../../context/auth';
import axios from 'axios';
import '../../styles/AdminStyles.css';

const AdminDashboard = () => {
  const [auth] = useAuth();
  const [productCount, setProductCount] = useState(0);
  const [orderCount, setOrderCount] = useState(0);
  const [categoryCount, setCategoryCount] = useState(0);
  const [paymentStats, setPaymentStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [pRes, cRes, oRes, payRes] = await Promise.all([
          axios.get("/api/v1/products/product-count"),
          axios.get("/api/v1/category/get-category"),
          axios.get("/api/v1/orders/all-guest-orders"),
          axios.get("/api/v1/payments/stats"),
        ]);
        setProductCount(pRes.data?.total || 0);
        setCategoryCount(cRes.data?.category?.length || 0);
        setOrderCount(Array.isArray(oRes.data) ? oRes.data.length : 0);
        if (payRes.data?.success) setPaymentStats(payRes.data.stats);
      } catch (e) {
        console.log(e);
      }
    };
    if (auth?.token) fetchStats();
  }, [auth?.token]);

  return (
    <Layout title={"لوحة الإدارة - النخبة ستور"}>
      <div className='container-fluid admin-layout'>
        <div className='row'>
          <div className='col-md-3'>
            <AdminMenu/>
          </div>
          <div className='col-md-9'>
            <div className="admin-page-header">
              <h1>مرحباً، {auth?.user?.name} 👋</h1>
              <p>مرحباً بك في لوحة إدارة النخبة ستور</p>
              <div className="admin-page-header-line"></div>
            </div>

            {/* Stats */}
            <div className="admin-stats-grid">
              <div className="admin-stat-card">
                <div className="admin-stat-icon">📦</div>
                <span className="admin-stat-value">{productCount}</span>
                <span className="admin-stat-label">المنتجات</span>
              </div>
              <div className="admin-stat-card">
                <div className="admin-stat-icon">🧾</div>
                <span className="admin-stat-value">{orderCount}</span>
                <span className="admin-stat-label">الطلبات</span>
              </div>
              <div className="admin-stat-card">
                <div className="admin-stat-icon">📁</div>
                <span className="admin-stat-value">{categoryCount}</span>
                <span className="admin-stat-label">الأقسام</span>
              </div>
              {paymentStats && (
                <div className="admin-stat-card">
                  <div className="admin-stat-icon">💳</div>
                  <span className="admin-stat-value">{paymentStats.completedPayments}</span>
                  <span className="admin-stat-label">مدفوعات مكتملة</span>
                </div>
              )}
            </div>

            {/* Payment Revenue */}
            {paymentStats && (
              <div style={{ display: "flex", gap: "16px", marginBottom: "28px", flexWrap: "wrap" }}>
                <div className="ap-summary-card">
                  <span className="ap-summary-label">إجمالي الإيرادات</span>
                  <span className="ap-summary-value">{(paymentStats.totalRevenue || 0).toLocaleString("ar-IQ")} د.ع</span>
                </div>
                <div className="ap-summary-card">
                  <span className="ap-summary-label">إيرادات اليوم</span>
                  <span className="ap-summary-value">{(paymentStats.todayRevenue || 0).toLocaleString("ar-IQ")} د.ع</span>
                </div>
                <div className="ap-summary-card">
                  <span className="ap-summary-label">طلبات اليوم</span>
                  <span className="ap-summary-value">{paymentStats.todayCount || 0} طلب</span>
                </div>
              </div>
            )}

            {/* Admin Info */}
            <div className="admin-info-card">
              <div className="admin-info-row">
                <div className="admin-info-icon">👤</div>
                <div>
                  <span className="admin-info-label">اسم المدير</span>
                  <span className="admin-info-value">{auth?.user?.name}</span>
                </div>
              </div>
              <div className="admin-info-row">
                <div className="admin-info-icon">📧</div>
                <div>
                  <span className="admin-info-label">البريد الإلكتروني</span>
                  <span className="admin-info-value">{auth?.user?.email}</span>
                </div>
              </div>
              <div className="admin-info-row">
                <div className="admin-info-icon">📱</div>
                <div>
                  <span className="admin-info-label">رقم الهاتف</span>
                  <span className="admin-info-value">{auth?.user?.phone}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdminDashboard;
